<div class="bg-main-container p-3">
  <div *ngIf="selectedTab === 'Global Package'" class="d-flex flex-column h-100">
    <div class="d-flex justify-content-between align-items-center p-3 pb-0">
      <div class="font-white">
        <div class="fs-16 fw-normal">{{ PackageID ? "Update" : "Create" }} membership plan.</div>
      </div>

      <div class="d-flex gap-3">
        <!-- <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" (click)="onClose()" tabindex="0" (keydown)="onClose()" class="cursor-pointer"></div> -->
      </div>
    </div>
    <div class="border-bottom mx-3 mb-2 mt-2"></div>

    <mat-dialog-content class="p-3 pt-0 overflow-x-hidden">
      @if(!PackageID){
      <div>
        <div class="form-check d-flex justify-content-end align-items-center gap-2">
          <input type="checkbox" class="form-check-input" id="localCheck" [(ngModel)]="isLocal" />
          <label class="form-check-label mt-1 font-white fs-16 fw-normal" for="localCheck">Area Wise Membership</label>
        </div>
      </div>
      } @if(ErrorMsg.length > 0){
      <div AsteriskMessage [messageList]="ErrorMsg"></div>
      }

      <div class="row g-3 mt-1 mx-0">
        @if(!PackageID){
        <div class="row mx-0" *ngIf="isLocal">
          <div class="col-md-6 col-12">
            <label for="AreaID" class="fs-14 fw-normal font-white">Area</label>
            <app-multi-select-dropdown
              label=""
              placeholder="Select Area"
              [isMultiSelect]="true"
              [items]="areaList"
              valueProperty="AreaID"
              displayProperty="AreaName"
              [(model)]="packageDetails.AreaIDs"
              (modelChange)="onAreaChange(true)">
            </app-multi-select-dropdown>
          </div>

          <div class="col-md-6 col-12">
            <label for="CenterID" class="fs-14 fw-normal font-white">Center</label>
            <app-multi-select-dropdown
              label=""
              placeholder="Select Center"
              [isMultiSelect]="true"
              [items]="centerList"
              valueProperty="CenterID"
              displayProperty="CenterName"
              [(model)]="packageDetails.CenterID">
            </app-multi-select-dropdown>
          </div>
        </div>
        }
        <div class="col-md-4 col-12">
          <label for="planName" class="fs-14 fw-normal font-white">Package Name <span class="text-danger">*</span></label>
          <input
            class="form-control bg-form-control border-0 font-white w-100"
            maxlength="45"
            [readonly]="PackageID"
            [(ngModel)]="packageDetails.PackageName"
            name="planName"
            placeholder="Plan Name" />
        </div>
        <div class="col-md-4 col-12">
          <label for="startDate" class="fs-14 fw-normal font-white">Start Date <span class="text-danger">*</span></label>
          <input
            class="form-control bg-form-control border-0 font-white"
            type="date"
            [readonly]="PackageID"
            [(ngModel)]="packageDetails.StartTime"
            name="startDate"
            [max]="packageDetails.EndTime || ''"
            placeholder="Start Date" />
        </div>
        <div class="col-md-4 col-12">
          <label for="endDate" class="fs-14 fw-normal font-white">End Date <span class="text-danger">*</span></label>
          <input
            class="form-control bg-form-control border-0 font-white"
            type="date"
            [readonly]="PackageID"
            [(ngModel)]="packageDetails.EndTime"
            [min]="packageDetails.StartTime || ''"
            name="endDate"
            placeholder="End Date" />
        </div>

        <div class="col-md-2 col-12">
          <label for="duration" class="fs-14 fw-normal font-white">Duration (in Months) <span class="text-danger">*</span></label>
          <input
            class="form-control bg-form-control border-0 font-white w-100"
            type="number"
            min="0"
            [readonly]="PackageID"
            [(ngModel)]="packageDetails.Duration"
            (ngModelChange)="calculateTotalDays()"
            name="duration"
            placeholder="Duration" />
        </div>

        <div class="col-md-2 col-12">
          <label class="fs-14 fw-normal font-white"> {{ isGSTInclusive ? "Total Amount" : "Base Amount" }} <span class="text-danger">*</span> </label>
          <input
            class="form-control bg-form-control border-0 font-white w-100"
            [readonly]="PackageID"
            type="number"
            min="0"
            [(ngModel)]="enteredAmount"
            (ngModelChange)="calculateAmounts()"
            placeholder="Enter Amount" />
        </div>

        <div class="col-md-2 col-12">
          <label for="renewalAmount" class="fs-14 fw-normal font-white">Renewal Amount</label>
          <input
            class="form-control bg-form-control border-0 font-white w-100"
            type="number"
            min="0"
            [readonly]="PackageID"
            [(ngModel)]="packageDetails.RenewAmount"
            name="renewalAmount"
            placeholder="Renewal Amount"
            (keydown)="preventMinus($event)" />
        </div>

        <!-- <div class="col-12 mt-2">
          <div class="font-white fs-16 fw-normal">Minimum Amount</div>
        </div> -->

        <div class="col-md-2 col-12">
          <label class="fs-14 fw-normal font-white">Minimum Amount in % </label>
          <input class="form-control bg-form-control border-0 font-white w-100" type="number" min="0" [(ngModel)]="minAmountPercent" (ngModelChange)="onMinAmountPercentChange()" />
        </div>

        <div class="col-md-2 col-12">
          <label class="fs-14 fw-normal font-white">Minimum Amount in Rs. </label>
          <input class="form-control bg-form-control border-0 font-white w-100" type="number" min="0" [(ngModel)]="minAmountRs" (ngModelChange)="onMinAmountRsChange()" />
        </div>
      </div>

      <div class="border-bottom mt-3 mb-3"></div>

      <div class="row mx-0">
        <div class="col-md-6 col-12">
          <div class="fw-bold fs-14 font-white">Amount Breakdown</div>
        </div>
        <div class="col-md-3 col-12"></div>
        <div class="col-md-3 col-12">
          <!-- <div class="d-flex justify-content-between">
            <div class="fs-12 font-gray-opacity fw-normal">Base Amount</div>
            <div class="fs-12 font-gray-opacity fw-normal">₹ {{ packageDetails.Amount }}</div>
          </div> -->
          <!-- <div class="d-flex justify-content-between">
            <div class="fs-12 font-gray-opacity fw-normal">CGST ({{ CGST }}%)</div>
            <div class="fs-12 font-gray-opacity fw-normal">₹ {{ packageDetails.CGST }}</div>
          </div>
          <div class="d-flex justify-content-between">
            <div class="fs-12 font-gray-opacity fw-normal">SGST ({{ SGST }}%)</div>
            <div class="fs-12 font-gray-opacity fw-normal">₹ {{ packageDetails.SGST }}</div>
          </div> -->
          <div class="d-flex justify-content-between mt-2">
            <div class="fs-14 fw-bold font-white">Total Payable</div>
            <div class="fs-14 fw-bold font-white">₹ {{ packageDetails.FinalAmount }}</div>
          </div>
        </div>
      </div>

      <div class="border-bottom mt-3 mb-3"></div>
      <div class="mt-3">
        <div class="row mx-0">
          <div class="col-md-12 col-12">
            <div class="d-flex gap-4 align-items-center mt-3 flex-wrap">
              <div class="form-check d-flex align-items-center gap-2">
                <input type="checkbox" class="form-check-input" id="activeCheck" [(ngModel)]="packageDetails.IsActive" />
                <label class="form-check-label font-white fs-14 fw-normal" for="activeCheck">Active</label>
              </div>

              <div class="form-check d-flex align-items-center gap-2">
                <input type="checkbox" class="form-check-input" id="upgradableCheck" [(ngModel)]="packageDetails.IsUpgradable" />
                <label class="form-check-label font-white fs-14 fw-normal" for="upgradableCheck">Upgradable</label>
              </div>

              <div class="form-check d-flex align-items-center gap-2">
                <input type="checkbox" class="form-check-input" id="renewableCheck" [(ngModel)]="packageDetails.IsRenewable" />
                <label class="form-check-label font-white fs-14 fw-normal" for="renewableCheck">Renewable</label>
              </div>
              <div class="form-check d-flex align-items-center gap-2">
                <input type="checkbox" class="form-check-input" id="transferableCheck" [(ngModel)]="packageDetails.IsTransferable" />
                <label class="form-check-label font-white fs-14 fw-normal" for="transferableCheck">Transferable</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="p-3 pt-0">
      <button class="close-btn me-2 px-4 py-1" (click)="onClose()">Close</button>
      <button class="add-btn px-4 py-1" (click)="addPackage()">{{ PackageID ? "Update" : "Create" }} Plan</button>
    </mat-dialog-actions>
  </div>
</div>
